export default __webpack_public_path__ + "static/media/logowhite.0ff3523c.png";